import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">焦点深扒</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-bold">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col gap-2 flex-1">
                <h3 className="text-base md:text-lg font-bold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.excerpt}
                </p>
              </div>
            </a>
          ))}

          {carouselItems.slice(3, 5).map((item) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col sm:flex-row rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer sm:col-span-2 lg:col-span-3"
            >
              <div className="relative w-full sm:w-56 md:w-64 flex-shrink-0 h-48 sm:h-auto overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-bold">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col gap-2 flex-1 justify-center">
                <h3 className="text-base md:text-lg font-bold text-foreground-800 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}